import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';


@Component({
  selector: 'app-dialog-box-cambio-estado',
  templateUrl: './dialog-box-cambio-estado.component.html',
  styleUrls: ['./dialog-box-cambio-estado.component.scss'],
  /*providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]*/
})
export class DialogBoxCambioEstadoComponent {

  action: string;
  motivo:string;
  LOCAL_DATA: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogBoxCambioEstadoComponent>,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.action = data.action;
    //Object.assign(this, { multi });
  }

  doAction(): void{
    this.dialogRef.close({event: this.action,motivo:this.motivo});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  ngOnInit(): void {


  }

}
